 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"abw":"abw","adminPages":"adminPages","allStocks~stockFeed":"allStocks~stockFeed","stockFeed":"stockFeed","battery":"battery","cultureMedicine":"cultureMedicine","feedView":"feedView","gatewayView":"gatewayView","harvestYield":"harvestYield","labTests":"labTests","manualFeeding":"manualFeeding","pondDetails":"pondDetails","pondFeeding":"pondFeeding","pondsMapAndFeeding~v2Dashboard":"pondsMapAndFeeding~v2Dashboard","pondsMapAndFeeding~settings":"pondsMapAndFeeding~settings","pondsMapAndFeeding":"pondsMapAndFeeding","userProfile":"userProfile","settings":"settings","v2Dashboard":"v2Dashboard","reports":"reports","resources":"resources","stockMedicine":"stockMedicine","allStocks":"allStocks","userConfirmAndPasswordsFunctions":"userConfirmAndPasswordsFunctions","userSignUpAndSignInFunctions":"userSignUpAndSignInFunctions","dashboardTab":"dashboardTab","pondAlertsTab":"pondAlertsTab","pondInfoTab":"pondInfoTab"}[chunkId]||chunkId) + "." + {"abw":"1894a8d3","adminPages":"eb29261d","allStocks~stockFeed":"6b39ce11","stockFeed":"9aed3a90","battery":"df6d81e5","cultureMedicine":"19dc72b9","feedView":"1a3ccb31","gatewayView":"bd826ab8","harvestYield":"7a67f234","labTests":"8767f76f","manualFeeding":"0c294e6b","pondDetails":"68c6bf51","pondFeeding":"3cd677fd","pondsMapAndFeeding~v2Dashboard":"fadd010d","pondsMapAndFeeding~settings":"3a14f9aa","pondsMapAndFeeding":"0a823c69","userProfile":"4b63bf1a","settings":"449b7794","v2Dashboard":"aa5a8c39","reports":"8917d0d7","resources":"113b7456","stockMedicine":"653227f6","allStocks":"a2138e07","userConfirmAndPasswordsFunctions":"0d9388a8","userSignUpAndSignInFunctions":"14f1ff85","dashboardTab":"a3b30b42","pondAlertsTab":"b4134dcd","pondInfoTab":"a306a14a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"abw":1,"adminPages":1,"allStocks~stockFeed":1,"battery":1,"cultureMedicine":1,"feedView":1,"gatewayView":1,"harvestYield":1,"labTests":1,"manualFeeding":1,"pondDetails":1,"pondFeeding":1,"pondsMapAndFeeding":1,"userProfile":1,"settings":1,"v2Dashboard":1,"reports":1,"resources":1,"stockMedicine":1,"allStocks":1,"userConfirmAndPasswordsFunctions":1,"userSignUpAndSignInFunctions":1,"dashboardTab":1,"pondAlertsTab":1,"pondInfoTab":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"abw":"abw","adminPages":"adminPages","allStocks~stockFeed":"allStocks~stockFeed","stockFeed":"stockFeed","battery":"battery","cultureMedicine":"cultureMedicine","feedView":"feedView","gatewayView":"gatewayView","harvestYield":"harvestYield","labTests":"labTests","manualFeeding":"manualFeeding","pondDetails":"pondDetails","pondFeeding":"pondFeeding","pondsMapAndFeeding~v2Dashboard":"pondsMapAndFeeding~v2Dashboard","pondsMapAndFeeding~settings":"pondsMapAndFeeding~settings","pondsMapAndFeeding":"pondsMapAndFeeding","userProfile":"userProfile","settings":"settings","v2Dashboard":"v2Dashboard","reports":"reports","resources":"resources","stockMedicine":"stockMedicine","allStocks":"allStocks","userConfirmAndPasswordsFunctions":"userConfirmAndPasswordsFunctions","userSignUpAndSignInFunctions":"userSignUpAndSignInFunctions","dashboardTab":"dashboardTab","pondAlertsTab":"pondAlertsTab","pondInfoTab":"pondInfoTab"}[chunkId]||chunkId) + "." + {"abw":"7f4a6a00","adminPages":"2671b73c","allStocks~stockFeed":"fb69295a","stockFeed":"31d6cfe0","battery":"dd9f5ea0","cultureMedicine":"4c6f2fc4","feedView":"9d87dca6","gatewayView":"49653a76","harvestYield":"4224f02e","labTests":"582c1ce9","manualFeeding":"6f054dbc","pondDetails":"4d0b4b8e","pondFeeding":"4ea44ec0","pondsMapAndFeeding~v2Dashboard":"31d6cfe0","pondsMapAndFeeding~settings":"31d6cfe0","pondsMapAndFeeding":"fe232a06","userProfile":"c55fda56","settings":"d889258a","v2Dashboard":"323350b2","reports":"2ca85a5f","resources":"5c1a8125","stockMedicine":"ed9240c0","allStocks":"7d9b20b7","userConfirmAndPasswordsFunctions":"efb4fb27","userSignUpAndSignInFunctions":"6ce82b5f","dashboardTab":"d84ae359","pondAlertsTab":"007c2e0f","pondInfoTab":"0027f629"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
